if (!customElements.get('product-x-get-y')) {
  customElements.define(
    'product-x-get-y',
    class ProductXGetY extends HTMLElement {

      connectedCallback() {
        const btn = this.submitButton;
        if (btn) btn.addEventListener('click', this.onSubmitHandler.bind(this));
      }

      get submitButton() {
        return this.querySelector('[data-product-x-get-y-submit]');
      }

      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.hasAttribute('aria-disabled')) return;

        const mainVariant = this.dataset.mainVariant;
        const giftVariant = this.dataset.giftVariant;
        const giftVariant2 = this.dataset.giftVariant2;
        const mainQuantity = parseInt(this.dataset.mainQuantity) || 1;
        const giftQuantity = parseInt(this.dataset.giftQuantity) || 1;
        const giftQuantity2 = parseInt(this.dataset.giftQuantity2) || 1;

        const type = this.dataset.type;
        this.activeElement = event.currentTarget;

        if (!mainVariant) {
          console.error('Main variant not set');
          return;
        }

        const items = [
          { id: mainVariant, quantity: mainQuantity },
        ];
        if (giftVariant) items.push({ id: giftVariant, quantity: giftQuantity,properties: { gift_for: mainVariant } });
        if (giftVariant2) items.push({ id: giftVariant2, quantity: giftQuantity2,properties: { gift_for: mainVariant } });

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');

        try {
          if (type === 'add-x-get-y-button') {
            // 加入购物车逻辑
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            }));

            const body = JSON.stringify({
              items,
              sections: sectionsToBundle,
              sections_url: window.location.pathname
            });

            const parsedState = await fetch(theme.routes.cart_add_url, {
              ...theme.utils.fetchConfig('javascript'),
              body
            }).then(res => res.json());

            const cartJson = await fetch(theme.routes.cart_url, {
              ...theme.utils.fetchConfig('json', 'GET')
            }).then(res => res.json());

            cartJson['sections'] = parsedState['sections'] || [];
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-x-get-y',
              cart: cartJson
            });

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
            this.cartDrawer?.show(this.activeElement);

          } else if (type === 'buy-x-get-y-button') {
            // buy now 会影响购物车 而且会覆盖购物车
            // 如果想要不影响购物车 需要app的方式调 storefront api
            const checkoutItems = items.map(item => `${item.id}:${item.quantity}`).join(',');
            const checkoutUrl = `${theme.routes.cart_url}/${checkoutItems}?checkout`;
            window.location.href = checkoutUrl;
          }
        } catch (err) {
          console.error(err);
        } finally {
          if(type === 'add-x-get-y-button'){
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.removeAttribute('aria-disabled');
          }
          
        }
      }

    }
  );
}
